export const setPapers = (state, payload) => state.papers = payload